import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms18e/mocker'
import moment from 'moment'
import _ from 'lodash'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms18e/labels')
  },
  getIndex (searchParams) {
    // return generator(mocker.index(searchParams))
    if (isMock) return generator(mocker.index(searchParams))
    let month = moment().month()
    let year = moment().year()
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      month = searchParams.month || moment().month()
      year = searchParams.year || moment().year()
      sendParams = {
        p_codcomp: searchParams.codcomp || '',
        p_codcalen: searchParams.codcalen || ''
      }
    }
    let param = month + '/' + year
    return instance().get(endpoint + '/hrms18e/index/' + param, { params: sendParams })
  },
  postIndex ({ searchIndex, sendParams }) {
    if (isMock) return generator(mocker.saveIndex())
    for (let parentIndex = 0; parentIndex < sendParams.parent.length; parentIndex++) {
      let parentRow = sendParams.parent[parentIndex]
      if (parentRow.flg === 'edit') {
        for (let day = 1; day <= 31; day++) {
          let dayPadStart = _.padStart(day, 2, '0')
          let codShiftDayPadStart = 'codshift' + dayPadStart
          let typworkDayPadStart = 'typwork' + dayPadStart
          if (typeof parentRow[codShiftDayPadStart + '-flgEdit'] === 'undefined') {
            delete parentRow[codShiftDayPadStart]
          } else {
            delete parentRow[codShiftDayPadStart + '-flgEdit']
          }
          if (typeof parentRow[typworkDayPadStart + '-flgEdit'] === 'undefined') {
            delete parentRow[typworkDayPadStart]
          } else {
            delete parentRow[typworkDayPadStart + '-flgEdit']
          }
        }
      }
    }

    for (let childIndex = 0; childIndex < sendParams.child.length; childIndex++) {
      let childRow = sendParams.child[childIndex]
      if (childRow.flg === 'edit') {
        for (let day = 1; day <= 31; day++) {
          let dayPadStart = _.padStart(day, 2, '0')
          let codcalenDayPadStart = 'codcalen' + dayPadStart
          let codShiftDayPadStart = 'codshift' + dayPadStart
          let typworkDayPadStart = 'typwork' + dayPadStart
          if (typeof childRow[codShiftDayPadStart + '-flgEdit'] === 'undefined') {
            delete childRow[codShiftDayPadStart]
            delete childRow[codcalenDayPadStart]
          } else {
            delete childRow[codShiftDayPadStart + '-flgEdit']
          }
          if (typeof childRow[typworkDayPadStart + '-flgEdit'] === 'undefined') {
            delete childRow[typworkDayPadStart]
            delete childRow[codcalenDayPadStart]
          } else {
            delete childRow[typworkDayPadStart + '-flgEdit']
          }
        }
      }
    }

    let saveParams = {
      param_json: JSON.stringify({
        detail: {
          codcalen: searchIndex.codcalen + '',
          month: searchIndex.month + '',
          year: searchIndex.year + ''
        },
        table1: sendParams.parent,
        table2: sendParams.child
      })
    }
    return instance().post(endpoint + '/hrms18e/save', JSON.stringify(saveParams))
  },
  getTraditionalAndShutdownDays (searchParams) {
    let sendParams = {
      p_codcomp: searchParams.codcomp || '',
      p_codcalen: searchParams.codcalen || ''
    }
    if (isMock) return generator(mocker.traditionalAndShutdownDays(searchParams.year))
    return instance().get(endpoint + '/hrms18e/traditionalAndShutdownDays/' + searchParams.year, { params: sendParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms18e/index.js